<template>
  <UiModal
    :show="showExchange"
    title="兑换商品"
    iconType="store_1"
    bottom-bg
    @close="close"
  >
    <div class="exchange">
      <div class="inner" v-if="productId">
        <div class="goods" :class="type">
          <div class="icon" :style="{'background-image': `url(${info.imgUrl})`}">
          </div>
          <div class="num">
            <div class="label-box">
              <span class="label-shadow">x{{ info.num }}</span>
              <span class="label-text">x{{ info.num }}</span>
            </div>
          </div>
        </div>
        <div class="select-box">
          <span>兑换数量</span>
          <div class="num-box">
            <i class="reduce" @click="exchangeNum('reduce')"></i
            ><span>{{ num }}</span
            ><i class="add" @click="exchangeNum('add')"></i>
          </div>
        </div>
      </div>
    </div>
    <div class="bottom">
      <div class="left-box">
        <div class="amount-surplus">
          <div class="label-box">
            <span class="label-shadow">消耗</span>
            <span class="label-text">消耗</span>
          </div>
          <i></i>
          <div class="label-box">
            <span class="label-shadow">{{ num * info.cost }}</span>
            <span class="label-text">{{ num * info.cost }}</span>
          </div>
        </div>
        <div v-if="isMall"  class="limit" >
          <div class="label-box">
            <span class="label-shadow">限购（{{ info.dailyReward }}/{{ info.dailyLimit }}）</span>
            <span class="label-text">限购（{{ info.dailyReward }}/{{ info.dailyLimit }}）</span>
          </div>
        </div>
        <div v-else class="limit">
          <div class="label-box">
            <span class="label-shadow">限购（{{ info.totalReward }}/{{ info.totalLimit }}）</span>
            <span class="label-text">限购（{{ info.totalReward }}/{{ info.totalLimit }}）</span>
          </div>
        </div>
      </div>
      <UiButton class="betting-btn" colorType="red" @click="submit">
        <div class="label-box">
          <span class="label-shadow">兑换</span>
          <span class="label-text">兑换</span>
        </div>
      </UiButton>
    </div>
  </UiModal>
</template>

<script setup>
import { ref, computed } from 'vue'
import { useAppStore } from '@/store'
import { useModal } from '@/composables/useModal'
import { usePrompt } from '@/composables/usePrompt'
import * as api from "@/service/index";
import UiModal from "@/components/ui-modal.vue";
import UiButton from '@/components/ui-button';

const appStore = useAppStore()

const info = ref({})
const showExchange = ref(false)
const productId = ref("")
const num = ref(1)
const type = ref("")
const inRequest = ref(false)
const isMall = ref('mall')

const { showPrompt } = usePrompt()

const { close } = useModal('store-exchange', showExchange, {
  onOpen(params) {
    // 触发方: appStore.openModal({ id: 'store-exchange', params: { goodList, type } })
    type.value = params.type
    isMall.value = params.type === 'mall'
    info.value = params.goodList
    productId.value = params.goodList.goodsId
  },
  onClose() {
    num.value = 1
    info.value = {}
    inRequest.value = false
  }
})

// 原 options 写法中存在 watch inputAmount（数据源 inputAmount/quizAmount/amountList 均不存在，
// 该 watcher 从不触发），属于死代码，转换时按原语义保留为注释：
// watch(inputAmount, (newAmount) => {
//   if (newAmount && newAmount > 0) {
//     quizAmount = newAmount;
//   } else {
//     quizAmount = amountList[2];
//   }
// })

const token = computed(() => appStore.token)
const amount = computed(() => appStore.amount)

// created
// console.log(' this.type', this.type)

function exchangeNum(mode) {
  //
  // let  amount= 9999
  let daily_diff =info.value.dailyLimit - info.value.dailyReward

  let total_diff =info.value.totalLimit - info.value.totalReward
  const limit = isMall.value ? daily_diff : total_diff;

  // if (mode === 'add' && this.amount.quizRemainNum >= (this.num + 1) * this.info.cost && this.num < limit) {
  //   this.num += 1;
  // } else if (mode === 'reduce' && this.num >= 2) {
  //   this.num -= 1;
  // }
  if(mode === 'add'){
    if(num.value < limit){
      if(amount.value.quizRemainNum >= (num.value + 1) * info.value.cost){
        num.value += 1;
      }else{
        showPrompt('竞猜币余额不足,无法增加')
      }
    }else{
      showPrompt('可兑换次数不足，无法增加')
    }
  }else if(mode === 'reduce'){
    if(num.value >= 2){
      num.value -= 1;
    }
  }

}

async function submit() {
  if (!inRequest.value) {
    inRequest.value = true;

    if(!token.value) return;
    let data = {
      productId: productId.value,
      num: num.value,
      token: token.value,
    };
    let response = await api.submitExchange(token.value, data);
    if (response.status === 200) {
        const tapdbTetx = isMall.value ? "每日商城" : "常驻商城"
      if (response.data === true) {
        if(isMall.value){
          info.value.dailyReward += num.value;
        }else {
          info.value.totalReward += num.value;
        }
        if(info.value.isSend){
          if(!token.value) return;
          const res =  await api.reqGiftList({token: token.value,force : true})
          if(typeof tapdb === 'undefined') return;
            if(res.status === 200){
              res.data?.find(item => {
              if(item.giftId === 'xc006'){
                // 获得道具余量
                tapdb.trackEvent(tapdbTetx, {
                  // 获得道具数量
                  '#item_gain': + info.value.coins,
                  // 道具变化余量
                  '#prop_after': item.count,
                  // 道具id
                  '#prop_id': item.giftId,
                  // 道具原因
                  '#prop_type' : info.value.title
                });
              }
            })
          }
        }else{
          appStore.reqUserInfo(true);

          if(typeof tapdb === 'undefined') return;
          tapdb.trackEvent(tapdbTetx, {
              // 竞猜币消耗总量
            '#value_change': info.value.cost * num.value,
            // 竞猜余量
            '#value_after': amount.value.quizRemainNum,
            // 货币id
            '#coin_id': "xc001",
            // 获得道具数量
            '#item_gain': num.value,
                // 获得道具
            '#prop_id': productId.value,
                // 获得变化原因
            '#via_type': info.value.title,
             // 获得道具原因
            '#prop_type' : info.value.title
          });


        }
        appStore.getGoodsList();
        appStore.reqRedDotState()

        showPrompt("兑换成功～");


        setTimeout(() => {
          close();
        }, 1500);
      } else {
        showPrompt(response.data);
      }
    } else {
      showPrompt(response.data);
    }


  }
}

</script>

<style lang="scss" scoped>
@import "./exchange";
</style>
